import { createSelector } from '@reduxjs/toolkit';
import { SLICE } from 'modules/dashboard/constants';
import { initialState } from './slice';

const selectDomain = (state) => state[SLICE.CUSTOM_CHAT] || initialState;

export const selectChatLoading = createSelector([selectDomain], (state) => state.loading);
export const selectChatResponse = createSelector([selectDomain], (state) => state.response);
export const selectChatError = createSelector([selectDomain], (state) => state.error);
// fallbacks cover a chat state restored from before the history fields were added
export const selectChatHistory = createSelector(
  [selectDomain],
  (state) => state.history ?? initialState.history
);
export const selectChatNextCursor = createSelector(
  [selectDomain],
  (state) => state.nextCursor ?? null
);
export const selectChatHistoryLoading = createSelector(
  [selectDomain],
  (state) => !!state.historyLoading
);
export const selectChatHistoryLoaded = createSelector(
  [selectDomain],
  (state) => !!state.historyLoaded
);
export const selectClearingChatHistory = createSelector(
  [selectDomain],
  (state) => !!state.clearingHistory
);
